import axios from "axios";
import { handleMoozikServiceError } from "./functions";

/** @type {"prod" | "preprod"} */
const env = "prod"; 
const baseUrls = {
  prod: "https://recharge.yas.mg/dashboard/moozik",
  preprod: "https://pre-recharge.telma.mg/dashboard/moozik",
};
const tokens = {
  prod: "vCwUeeHRAlA2hE9FdLc-nVa6-T4xbtbg_XfqezVeLvZ8WvwPKSrRJYbcd8eol95gKzB-KybmSOXKkJ6KFFDHdHe2",
  preprod:
    "v55bJ9WwS4sE1jfqvJG2wt8431HRE_ChiYCXSi6K3YjCLB-grvgMh2sUs1Rj8agEyXgBfqdfxPRvzbAqv-sXjN8G",
};
const keys = {
  prod: "4Wnn8S5CxQhRH5ZaUfD99KAx3tUV24QCANkcRNcqAXD3",
  preprod: "2RQ6xLR3zdc4Fkgia4t3mwkbgHzDoauLSVeqmvszHYxW",
};
const xApiKeys = {
  prod: "EsGFzlmLTHo93VzMRgYFGYjq1ycqk12v4OOFMAKpbUe1gv48Wm2DWDmI9BPHU5GUIMxIGIOvuBFdpIbYXE7ANANruhBXNCcRojJth9yBjedbc9ZNU7Uv1Lo9U9LEuSM9",
  preprod:
    "iUUbyQZpjvTBS7rrEM6W2nKO4IvW4ISFhYnkSjt62MUwMMdKHN5LVzawjb8ooSInAdeAFjzDO8jJf79ydjBM7O9lZ6vSZAKwtXRaAbKC5S8QBcfBpu3PqShEXpCQfb3k",
};

// --------------------------------------------------_

const token = tokens[env];
const Keys = keys[env];
const baseUrl = baseUrls[env];
const xApiKey = xApiKeys[env];

const MoozikServicesAPI = axios.create({
  baseURL: baseUrl,
  timeout: 30_000,
  headers: {
    Authorization: `Bearer ${token}`,
    "x-api-key": xApiKey, // 020824
    "Content-Type": "application/json",
  },
});

const makeRequest = (data) => MoozikServicesAPI.post("", data);

// --------------------------------------------------_

const MoozikServices = {
  getList: async () => {
    try {
      const request = await makeRequest({
        keys: Keys,
        action: "LP",
      });

      // TODO handle response
      switch (request.status) {
        case 200:
        case 201:
          return request.data;
        default:
          const response = handleMoozikServiceError(request.data);
          throw response;
      }
    } catch (error) {
      console.log("====================================");
      console.log("-- getList error");
      const err = handleMoozikServiceError(error?.response || error);
      throw err;
    }
  },

  registerOffer: async ({ rpid }) => {
    try {
      const request = await makeRequest({
        keys: Keys,
        rpid: rpid,
        action: "JP",
      });

      // TODO handle response
      switch (request.status) {
        case 200:
        case 201:
          return request.data;
        default:
          const response = handleMoozikServiceError(request.data);
          throw response;
      }
    } catch (error) {
      console.log("====================================");
      console.log("-- offerChoice error");
      const err = handleMoozikServiceError(error?.response || error);
      throw err;
    }
  },

  identifyMsisdn: async ({ rpid, msisdn }) => {
    try {
      const request = await makeRequest({
        msisdn,
        keys: Keys,
        rpid: rpid,
        action: "IDT",
      });

      // TODO handle response
      switch (request.status) {
        case 200:
        case 201:
          return request.data;
        default:
          const response = handleMoozikServiceError(request.data);
          throw response;
      }
    } catch (error) {
      console.log("====================================");
      console.log("-- identifyMsisdn error");
      const err = handleMoozikServiceError(error?.response || error);
      throw err;
    }
  },

  verifyOTP: async ({ rpid, msisdn, otp }) => {
    try {
      const request = await makeRequest({
        msisdn,
        keys: Keys,
        rpid: rpid,
        otp,
        action: "VF",
      });

      // TODO handle response
      switch (request.status) {
        case 200:
        case 201:
          return request.data;
        default:
          const response = handleMoozikServiceError(request.data);
          throw response;
      }
    } catch (error) {
      console.log("====================================");
      console.log("-- verifyOTP error");
      const err = handleMoozikServiceError(error?.response || error);
      throw err;
    }
  },

  buyOffer: async ({ msisdn, rpid, payment_type }) => {
    try {
      const request = await makeRequest({
        msisdn,
        keys: Keys,
        rpid: rpid,
        payment_type,
        action: "BUY",
      });

      // TODO handle response
      switch (request.status) {
        case 200:
        case 201:
          return request.data;
        default:
          const response = handleMoozikServiceError(request.data);
          throw response;
      }
    } catch (error) {
      console.log("====================================");
      console.log("-- buyOffer error");
      const err = handleMoozikServiceError(error?.response || error);
      throw err;
    }
  },
};

export default MoozikServices;
